import type { GuidedAnswer, GuidedModeCollection } from '../types/guided-mode.types'

export const AUTO_PROGRESS_DELAY_MS = 400

interface AutoProgressContext {
  answer: GuidedAnswer
  collection: GuidedModeCollection
  selectedOptions: string[]
}

export function shouldAutoProgress({
  answer,
  collection,
  selectedOptions,
}: AutoProgressContext): boolean {
  if (collection.type === 'option') {
    if (collection.selection !== 'multiple') return selectedOptions.length > 0

    const exclusiveValues = new Set(collection.exclusiveValues || [])
    return selectedOptions.some(value => exclusiveValues.has(value))
  }

  return typeof answer === 'string'
    && answer.toLowerCase() === 'unknown'
    && collection.allowUnknown === true
}
